import React from "react";
import { withRouter } from "react-router-dom";
import './tabBar.less'

const tabList = [
  { path: '/', name: '首页', icon: 'icon-shouye' },
  { path: '/property', name: '资产', icon: 'icon-zichan' },
  { path: '/orders', name: '订单', icon: 'icon-dingdan' },
  { path: '/my', name: '我的', icon: 'icon-shouru' }
]

class TabBar extends React.Component {
  constructor() {
    super();
    this.state = {
      curTab: '/'
    }
  }
  componentDidMount() {
    this.setState({ curTab: this.props.location.pathname });
  }
  
  tabClick(path) {
    this.setState({ curTab: path });
    this.props.history.push({ pathname: path });
  }

  render() {
    return (
      <div className="tabbar-wrap">
        <ul className="tablist cflex scale-1px-top">
          {tabList.map(item => 
            <li className={`tabitem ${this.state.curTab==item.path?'tabitem-active':''}`} key={item.path} onClick={() => this.tabClick(item.path)}>
              <p className={`tab-icon iconfont ${item.icon}`}></p>
              <p className="tab-name">{item.name}</p>
            </li> 
          )}
        </ul>
      </div>
    )
  }
}

export default withRouter(TabBar);